import React from 'react';
import './ContactButton.css'; // Import CSS for styling

const ContactButton = () => {
  return (
    <a 
      href="https://t.me/fablyfun" 
      target="_blank" 
      rel="noopener noreferrer"
      className="contact-sticky-button"
    >
      {/* Optional: Add a Telegram Icon here later */}
      Contact us!
    </a>
  );
};

export default ContactButton; 